import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../util/media'

export const CardModuleWrapper = styled.div`
  padding: 24px;
  border: 3px solid ${({ theme }) => theme.colors.primary};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ ghost }) =>
    ghost &&
    `
    border: 0;
    padding: 0;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${isNaN(marginBottom) ? marginBottom : `${marginBottom}px`};
  `}
`

export const CardModuleHeading = styled.div`
  margin-bottom: 12px;
`

export const CardModuleBody = styled.div`
  flex: 1;
`

export const CardModuleFooting = styled.div`
  margin-top: 12px;
`

export const CardModulePrice = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-family: ${({ theme }) => theme.font[1]};
`

export const CardModuleOldAmount = styled.span`
  font-size: ${rem(14)};
  white-space: nowrap;
`

export const CardModuleAmount = styled.span`
  font-size: ${rem(14)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
`
